import * as React from 'react'

import {Box, Button, Heading, Spinner, Stack, Table, Tbody, Td, Th, Thead, Tr} from '@chakra-ui/react'
import {Link, generatePath} from 'react-router-dom'

import {MyWebinar} from '@/api/models'
import ReviewModalButton from '@/common/reviews/review-modal/button'
import useSupabaseQuery from '@/common/use-custom-query'
import {PSYCHOTHERAPY_THERAPIST} from '@/router/paths'
import {formatTimestamp} from '@/utils/string'

const WebinarsHistory = () => {
  const {data, loading, fetch} = useSupabaseQuery<MyWebinar>(
    React.useMemo(
      () => ({
        table: 'my_webinars',
        fields: '*',
        order: 'end_at',
        descending: true,
        errSnackbarTitle: 'Nie udało się pobrać informacji o historii webinarów',
        finalize: (b) => b.lt('end_at', new Date().toUTCString()),
      }),
      []
    )
  )

  return !data?.length && !loading ? null : (
    <Stack spacing={12}>
      <Heading size="md">Historia webinarów</Heading>
      {loading ? (
        <Spinner size="xl" />
      ) : (
        <Table>
          <Thead display={['none', null, 'table-header-group']}>
            <Tr>
              <Th textTransform="none" fontSize="md" color="block" fontWeight={500} pl={0}>
                Data
              </Th>
              <Th textTransform="none" fontSize="md" color="block" fontWeight={500}>
                Nazwa
              </Th>
              <Th textTransform="none" fontSize="md" color="block" fontWeight={500}>
                Prowadzący
              </Th>
              <Th />
            </Tr>
          </Thead>
          <Tbody>
            {data?.map((m, i) => (
              <Row key={i} item={m} fetch={fetch} />
            ))}
          </Tbody>
        </Table>
      )}
    </Stack>
  )
}

const Row = ({item, fetch}: {item: MyWebinar; fetch: () => void}) => (
  <Tr fontWeight={300} fontSize="md">
    <Td display={['none', null, 'table-cell']} pl={0}>
      {formatTimestamp(item.start_at)}
    </Td>
    <Td display={['none', null, 'table-cell']}>{item.name}</Td>
    <Td px={[0, null, 6]}>
      <Box display={['block', null, 'none']} mb={2}>
        {formatTimestamp(item.start_at)}
      </Box>
      <Box display={['block', null, 'none']} mb={2}>
        {item.name}
      </Box>
      <Stack align="flex-start">
        {item.hosts.map(
          (h, i) =>
            !!h.therapist_id && (
              <Button
                key={i}
                variant="brandLink"
                as={Link}
                to={generatePath(PSYCHOTHERAPY_THERAPIST, {id: h.therapist_id})}
              >
                {h.full_name}
              </Button>
            )
        )}
      </Stack>
    </Td>
    <Td textAlign="center" px={[0, null, 6]}>
      <ReviewModalButton reviewed={item.reviewed} type="webinar" itemID={item.meeting} onComplete={fetch} />
    </Td>
  </Tr>
)

export default WebinarsHistory
